export const CONTACT_FORM = {
  'name': {
    'placeholder': 'Name',
    'error': {
      'minlength': 'Please enter a valid name',
      'maxlength': 'Maximum character limit exceeds',
      'pattern': 'Please enter a valid name'
    },
  },
  'email': {
    'placeholder': 'Email Address',
    'error': {
      'email': 'Please enter a valid email',
      'pattern': 'Please enter a valid email',
    },
  },
  'message': {
    'placeholder': 'Enter a message',
    'error': {
      'minlength': 'Please enter a valid message',
    },
  },
};
